export function renderPageImportsTemplate({
  plural,
  kebabPlural
}: {
  plural: string
  kebabPlural: string
}): string {
  return `import { getSetting } from '@admin/actions/settings'
import * as React from 'react'
import { columns } from './columns'
import { ${plural}PageContent } from './${kebabPlural}-page-content'
import { ${plural}PageSkeleton } from './${kebabPlural}-page-skeleton'

export default async function ${plural}Page() {
  const initialSettings = await getSetting()

  return (
    <React.Suspense fallback={<${plural}PageSkeleton />}>
      <${plural}PageContent columns={columns} initialSettings={initialSettings} />
    </React.Suspense>
  )
}
`
}
